import React from 'react'
import cx from 'classnames'
import styles from './SwitchCheckbox.sass'
import { HtmlAttributes } from 'csstype'

export interface Props extends React.HtmlHTMLAttributes<HtmlAttributes> {
  danger?: boolean
  success?: boolean
  trueLabel?: string
  falseLabel?: string
  value?: boolean
  disabled?: boolean
  saving?: boolean
  noText?: boolean
  onChange(e: unknown): void
  'data-test'?: string
}

export const SwitchCheckbox = ({
  className,
  danger,
  success,
  onChange,
  trueLabel = 'On',
  falseLabel = 'Off',
  noText = false,
  value = false,
  saving = false,
  disabled = false,
  'data-test': dataTest,
}: Props) => {
  value = !!value
  return (
    <div
      role="checkbox"
      className={cx(
        styles.root,
        className,
        danger && styles.danger,
        success && styles.success,
        value && styles.checked,
        saving && !disabled && styles.saving,
        disabled && styles.disabled,
      )}
      aria-checked={value ? 'true' : 'false'}
      aria-disabled={disabled || saving ? 'true' : 'false'}
      onClick={() => !disabled && !saving && onChange(!value)}
      data-test={dataTest}
    >
      {noText ? (
        <div className={styles.noText}></div>
      ) : (
        <div className={styles.text}>{value ? trueLabel : falseLabel}</div>
      )}

      <div className={styles.toggler} />
    </div>
  )
}
